import {sendEvent} from './analytics';
import {downloadLinkByPlatformMap, TPlatformType} from './downloadLinkByPlatformMap';

const getPremiseUrl = (type: TPlatformType) => {
  switch (type) {
    case 'chrome':
      return import.meta.env.VITE_ON_PREMISE_APPS_CHROME_URL;
    case 'windows':
      return import.meta.env.VITE_ON_PREMISE_APPS_WINDOWS_URL;
  }
};
export const downloadAgent = (type: TPlatformType) => {
  if (import.meta.env.VITE_ON_PREMISE_CLIENT_ID) {
    window.open(getPremiseUrl(type), '_blank');
  } else {
    sendEvent(`apps/click-${type}`);
    window.open(downloadLinkByPlatformMap.get(type), '_blank');
  }
};
